/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Field_AddressInputs */



/**
* | output |
* | --- |
* | "Address" |
*
* @param {Nda_Field_AddressInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_field_address = /** @type {((inputs?: Nda_Field_AddressInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Field_AddressInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Adresse")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dirección")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Endereço")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indirizzo")
	return /** @type {LocalizedString} */ ("Address")
});